import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { routerTransition, routerTransitionToLeft } from "../route.animations";
import { Lightbox, IAlbum } from 'angular2-lightbox';

import { ImageService } from "../service/app.image.service"
import { TileModel } from '../models/tile.model';

@Component({
    selector: "app-camera",
    templateUrl: "./app.camera.component.html"
})
export class CameraComponent implements OnInit {
    private _imageService: ImageService;
    public data: Array<TileModel>;
    private _albums: Array<IAlbum> = [];

    constructor(private im: ImageService, private _lightbox: Lightbox,
        private _router: Router) {
        this._imageService = im;
    }

    ngOnInit() {
        this.data = new Array<TileModel>();
        this._albums = new Array<IAlbum>();

        this._imageService.onGetTile()
            .subscribe(s => {
                let d = s.json();

                d.forEach(element => {

                    if (this.data.find(x => x.name == element.name))
                        return;

                    this.data.push(element);

                    const album = {
                        src: element.fullPath,
                        thumb: element.tilePath,
                        caption: element.name
                    };

                    this._albums.push(album);
                });
            });
    }

    open(index: number): void {
        this._lightbox.open(this._albums, index - 1);
    }

    openArchive(index: number): void {
        this._router.navigate(["history", index])
    }
}


// WEBPACK FOOTER //
// C:/pgutev/work/WEBCAM/src/app/camera/app.camera.component.ts